<av-content-container [fullHeight]="true">
    <!-- HEADER SECTION -->
    <div class="d-flex flex-column">
        <div class="text-center my-2">
            <h1 class="mb-1">{{ 'app.settings.user_create.title' | translate }}</h1>
            <p class="m-0">{{ 'app.settings.user_create.subtitle' | translate }}</p>
        </div>

        @if (rbacOff()) {
        <app-user-create-step-1 [formGroup]="userFormGroup" />

        <div class="d-flex justify-content-between align-items-center mt-4 pt-2 inline-20">
            <button mat-button (click)="onCancel()">
                <mat-icon iconPositionStart>arrow_back</mat-icon>
                {{ 'shared.general.buttons.cancel' | translate }}
            </button>
            <button mat-flat-button color="primary" (click)="onSubmit()"
                [disabled]="userFormGroup.invalid || !facade.selectedUser()"
                class="rounded-full shadow-1 button-compact">
                <mat-icon iconPositionStart>person_add</mat-icon>
                {{ 'app.settings.user_create.step2.submit_button' | translate }}
            </button>
        </div>
        } @else {
        <!-- MAIN STEPPER -->
        <mat-stepper linear #stepper>
            <!-- STEP 1: INTUNE USER SEARCH -->
            <mat-step [stepControl]="userFormGroup" [label]="'app.settings.user_create.steps.select_user' | translate" class="h-100">
                <app-user-create-step-1 [formGroup]="userFormGroup" />
            </mat-step>

            <!-- STEP 2: ROLE ASSIGNMENT -->
            <mat-step [stepControl]="roleFormGroup" [label]="'app.settings.user_create.steps.assign_role' | translate" class="h-100">
                <app-user-create-step-2 [formGroup]="roleFormGroup" (submitRequested)="onSubmit()" />
            </mat-step>

        </mat-stepper>
        }
    </div>
</av-content-container>